import "@hotwired/turbo-rails";
import "./controllers";
import "alpine-turbo-drive-adapter";
import Alpine from "alpinejs";
import "trix";
import "@rails/actiontext";
import Rails from "@rails/ujs";

window.Alpine = Alpine;
Alpine.start();

window.Rails = Rails;

window.addFields = function (link, association, content, place) {
  var newid = new Date().getTime();
  var regexp = new RegExp("new_" + association, "g");
  $(`#${place}`).append(content.replace(regexp, newid));
};

window.addEventListener("trix-file-accept", function (event) {
  event.preventDefault();
  alert("File attachment not supported!");
});